import CrudCustom from '../../../libs/custom/CrudCustom';


let PenyusutanPeriodeAsetService = new CrudCustom('/penyusutan-periodes');
export default PenyusutanPeriodeAsetService;
